import { IMicroInterlink, TMicroDefinition, TViewDefinition } from '../types/configuration';

import { View } from'../../../pip/library/pi-interop/pi-interop.js';
import { IRegion } from'../../../dip/library/di-hnf/di-hnf.js';
import $ip from'../../../pip/library/pi-ip/pi-ip.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export class ResourceLoader {
  /**
   * accept a regin and return a resource to parse as a view
   */
  static loadView(region: IRegion, preloadedViews: Record<string, View>): Promise<TViewDefinition> {
    const viewURI = region.view_uri || region.view;
    const viewPreloaded = region.view_preloaded;
    const viewTag = region.view_tag;

    if (viewPreloaded && preloadedViews[viewPreloaded]) {
      return f1.done(preloadedViews[viewPreloaded]);
    }

    // @todo how do I handle no definition?
    return f1.is.exists(viewTag)
      ? f1.done(viewTag)
      : f1.is.exists(viewURI)
      ? $ip.require<TViewDefinition>(`${viewURI}?resource_type=module`)
      : f1.done(null);
  }

  /**
   *
   */
  static loadMicro(external: IMicroInterlink): Promise<TMicroDefinition> {
    const resourceURI = external.source_uri;

    return f1.is.exists(resourceURI)
      ? $ip.require<TMicroDefinition>(`${resourceURI}?resource_type=module`)
      : Promise.resolve(null);
  }

  static activeView(region: IRegion): string {
    return region.view_preloaded || region.view_tag || region.view_uri || region.view || 'no view';
  }
}
